import { Controller } from "@hotwired/stimulus";

// Sizes a Calendly inline iframe to the height Calendly reports, so the booking page does not
// scroll inside the frame. Heights below `minHeight` (the loading spinner) are ignored.
export default class extends Controller {
  static values = { url: String, minHeight: { type: Number, default: 600 } };

  connect() {
    const url = new URL(this.urlValue);
    url.searchParams.set("embed_domain", window.location.host);
    url.searchParams.set("embed_type", "Inline");
    this.element.src = url.toString();

    this.onMessage = (event) => {
      if (event.origin !== "https://calendly.com" || event.source !== this.element.contentWindow) return;
      if (event.data?.event !== "calendly.page_height") return;

      const height = parseInt(event.data.payload?.height, 10);
      if (height >= this.minHeightValue) this.element.style.height = `${height}px`;
    };
    window.addEventListener("message", this.onMessage);
  }

  disconnect() {
    window.removeEventListener("message", this.onMessage);
  }
}
